import { EPDDetailOUT, Materials2050EPDDetailOUT } from "api-client";
import { useComplianceInfo } from "hooks/useComplianceInfo";
import React from "react";
import { useTranslation } from "react-i18next";

const Conformity = ({
  details,
}: {
  details: Materials2050EPDDetailOUT | EPDDetailOUT | null;
}) => {
  const { t } = useTranslation();
  const { getCertificationChipsGroup } = useComplianceInfo();

  return (
    <div className="mb-4">
      <div className="font-semibold text-base mb-3">
        {t("productEditor.conformity")}
      </div>
      <div className="flex items-center flex-wrap border-b border-gray-200 pb-4">
        <div className="mr-4">
          <div className="text-gray-600 text-sm font-medium pb-2">
            {t("productEditor.compatibilityForCertification")}
          </div>
          <div className="flex">
            {getCertificationChipsGroup(details?.compliant_certifications)}
          </div>
        </div>
        <div>
          <div className="text-gray-600 text-sm font-medium pb-2 mt-3">
            {t("productEditor.epdStandardTitle")}
          </div>
          <div className="text-gray-500 text-sm">
            {details?.conformities?.join(", ")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Conformity;
